import React, { useContext, useState } from 'react';
import styles from './style.module.css';
import PropTypes from 'prop-types';
import MobileContext from 'context/MobileContext';
import TabletContext from 'context/TabletContext';
import {
  hidePassword,
  hidePasswordErr,
  showPassword,
  showPasswordErr,
  warning,
} from 'assets/newIcons';

const PasswordTextfield = ({
  placeholder,
  onChange,
  value,
  invalid,
  error,
  name,
  onBlur,
  disabled,
  marginTop,
}) => {
  const isTablet = useContext(TabletContext);
  const isMobile = useContext(MobileContext);
  const mobClassName = isMobile ? styles.mob : isTablet ? styles.tab : null;

  const [showPass, setshowPass] = useState(false);
  const togglePassword = () => {
    setshowPass(!showPass);
  };

  const showPassCondition = showPass
    ? invalid
      ? hidePasswordErr
      : hidePassword
    : invalid
    ? showPasswordErr
    : showPassword;

  return (
    <div style={{ marginTop }} className={styles.body}>
      <div
        className={`${styles.field} ${
          error && invalid ? styles.err : ''
        } ${mobClassName}`}
      >
        <input
          className={`${styles.input} ${mobClassName}`}
          onChange={onChange}
          placeholder={placeholder}
          value={value}
          invalid={invalid}
          error={error}
          name={name}
          onBlur={onBlur}
          disabled={disabled}
          type={showPass ? 'text' : 'password'}
        />
        <img
          alt=""
          src={showPassCondition}
          onClick={() => togglePassword()}
          className={`${styles.icon}`}
        />
      </div>
      <div
        className={`${styles.errorDiv} ${
          !invalid && !error && !error ? styles.hide : null
        }`}
      >
        {error && invalid ? (
          <img className={styles.warning} alt="" src={warning} />
        ) : null}
        <p className={`${styles.error} ${mobClassName}`}>{invalid && error && error}</p>
      </div>
    </div>
  );
};

PasswordTextfield.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};

PasswordTextfield.defaultProps = {
  placeholder: '',
};
export default PasswordTextfield;
